import styled from "styled-components";

export const Text = styled.p`
  font-size: 18px;
  color: ${(props) => props.error && "#e0991c"};
  margin-bottom: 7px;
  font-size: 16px;
  font-weight: 600;
`;
